//react ,components
import React from "react";
import "./NavigationBar.scss";
import { Strings } from "../../Resources/Strings/i18n";
import "../../Resources/Styles/fonts.scss";
import { withRouter } from "react-router-dom";

//Bottom navbar Items
import NavAlertSelected from "../../Resources/Images/ic_alert_selected.png";
import NavAlert from "../../Resources/Images/ic_alert.png";
import NavCareCircleSelected from "../../Resources/Images/ic_care_circle_selected.png";
import NavCareCircle from "../../Resources/Images/ic_care_circle.png";
import NavHomeSelected from "../../Resources/Images/ic_home_selected.png";
import NavHome from "../../Resources/Images/ic_home.png";
import NavMessage from "../../Resources/Images/ic_message.png";
import NavMessageSelected from "../../Resources/Images/ic_message_selected.png";
import NavSettingsSelected from "../../Resources/Images/ic_settings_selected.png";
import NavSettings from "../../Resources/Images/ic_settings.png";

class NavigationBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loved_ones: [],
      careGivers: [],
      selectedMenuPath: "home",
    };
  }
  
  navItems = [
    {
      id: "menu1",
      menuName: Strings("Home"),
      img: {
        imgSrc: NavHome,
        selectedImgSrc: NavHomeSelected,
        alt: "Nav Home page",
      },
      path: "home",
      disabled: false,
    },
    {
      id: "menu2",
      menuName: Strings("CareCircle"),
      img: {
        imgSrc: NavCareCircle,
        selectedImgSrc: NavCareCircleSelected,
        alt: "Nav CareCircle page",
      },
      path: "carecircle",
      disabled: false,
    },
    {
      id: "menu3",
      menuName: Strings("Message"),
      navLink: "",
      img: {
        imgSrc: NavMessage,
        selectedImgSrc: NavMessageSelected,
        alt: "Nav Messsage page",
      },
      path: "",
      disabled: true,
    },
    {
      id: "menu4",
      menuName: Strings("Alerts"),
      img: {
        imgSrc: NavAlert,
        selectedImgSrc: NavAlertSelected,
        alt: "Nav Alert page",
      },
      path: "alerts",
      disabled: false,
    },
    {
      id: "menu5",
      menuName: Strings("Settings"),
      navLink: "",
      img: {
        imgSrc: NavSettings,
        selectedImgSrc: NavSettingsSelected,
        alt: "Nav Settings page",
      },
      path: "settings",
      disabled: false,
    },
  ];

  componentDidMount() {
    this.setState({
      selectedMenuPath: window.location.href,
    });
  }
  
  menuClick = (navItem) => {
   
    this.props.history.push({
      pathname: "/" + navItem.path,
    });
  };

  render() {
    return (
      <div className="NavigationBar">
        {this.navItems.map((navItem) => {
          const menuClasses = ["navItems"];
          if (this.props.path.includes(navItem.path)) {
            menuClasses.push("active");
          }
          if (navItem.disabled) {
            menuClasses.push("disabled");
          }

          return (
            <div
              key={navItem.menuName}
              className={menuClasses.join(" ")}
              onClick={() => this.menuClick(navItem)}
            >
              <img
                className="navImg"
                src={
                  this.props.path.includes(navItem.path)
                    ? navItem.img.selectedImgSrc
                    : navItem.img.imgSrc
                }
                alt={navItem.img.alt}
              />
              <div className="navText">{navItem.menuName}</div>
            </div>
          );
        })}

       
      </div>
    );
  }
}

export default withRouter(NavigationBar);
